import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollUpdateUserPerquisiteAssignmentsResponse,
  PayrollUpdateUserPerquisiteAssignmentsVariables,
} from './types';

export const updateUserPerquisiteAssignmentsMutation = gql`
  mutation PayrollUpdateUserPerquisiteAssignments(
    $userComponent: [UpdatePerquisiteComponentAssignmentInput!]!
  ) {
    payrollUpdateUserPerquisiteAssignments(userComponent: $userComponent) {
      data
      code
      success
      message
    }
  }
`;

const updateUserPerquisiteAssignments = (
  queryVariables: PayrollUpdateUserPerquisiteAssignmentsVariables,
) => {
  return graphQLApi<
    PayrollUpdateUserPerquisiteAssignmentsResponse,
    PayrollUpdateUserPerquisiteAssignmentsVariables
  >({
    query: updateUserPerquisiteAssignmentsMutation,
    queryVariables,
  });
};

export default updateUserPerquisiteAssignments;
